import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  rules;
  constructor(private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit() {
    this.rules = this.route.snapshot.data['rule'];
    if (this.rules.count > 0) {
      this.router.navigate(['/rules/list']);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/rules/landing/landing.component.ts